import { render, staticRenderFns } from "./MoreOn.vue?vue&type=template&id=031d0450&scoped=true&lang=pug&"
import script from "./MoreOn.vue?vue&type=script&lang=ts&"
export * from "./MoreOn.vue?vue&type=script&lang=ts&"
import style0 from "./MoreOn.vue?vue&type=style&index=0&id=031d0450&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031d0450",
  null
  
)

component.options.__file = "MoreOn.vue"
export default component.exports